import { Program } from 'models/Program';
import Api from 'services/PtmApi';
import { LoginService } from './LoginService';
import { ApiError } from 'models/ApiError';

export class ProgramService
{
    public programs: Array<Program> | undefined;
    private loginService: LoginService;

    constructor(loginService: LoginService)
    {
        this.loginService = loginService;
    }

    public getUserPrograms(): Promise<Array<Program>>
    {
		const session = this.loginService.getSession();

		if (session === undefined)
			return Promise.reject("No session");

		if (typeof session.accessToken !== 'string')
            return Promise.reject(ApiError.InvalidAccessToken);
            
        if (this.programs !== undefined)
            return Promise.resolve(this.programs);

        let url = Api.getBaseUrl() + 'v1/program';

        let init = {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + session.accessToken
            }
        };

        return fetch(url, init).then((response: Response) =>
        {
            if (response.status === 200)
                return response.json();
            else
                throw new Error("Request failed, status: " + response.status);
        }).then((jsonObject: any) =>
        {
            console.log(jsonObject);

            if (typeof jsonObject === 'object' &&
                Array.isArray(jsonObject['programs']))
            {
                let programs = new Array<Program>();

                for (let item of jsonObject['programs'])
                {
                    let program = Program.fromJson(item);

                    if (program !== undefined)
                        programs.push(program);
                }

                this.programs = programs;
                return this.programs;
            }
            else
            {
                throw new Error("Parsing program data failed");
            }
        }
        ).catch(reason => Promise.reject(reason));
    }
}